import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Highlight = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M21 7.12c0-.534-.208-1.036-.586-1.414l-2.121-2.12c-.756-.756-2.072-.756-2.828 0l-9.839 9.838c-.133.133-.225.3-.268.482l-1.021 4.422L3 20h2.828l.525-.496 3.74-.863a.991.991 0 0 0 .482-.268l9.839-9.839c.378-.378.586-.88.586-1.414zM9.868 16.252l-2.121-2.121L16.879 5 19 7.12l-9.132 9.132zM13 18h9v2h-9z", key: "k0" })));
});
Highlight.displayName = 'Highlight';
export var HighlightDimensions = { height: 24, width: 24 };
